import SearchNotificationImage from '@assets/svg/search-notification.svg';
import Rolling from '@assets/gif/rolling.gif';
import { ClickAwayListener } from '@material-ui/core';
import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import {
  LoadingImg,
  Search,
  SearchButton,
  SearchContainer,
  SearchImg,
  StyledOption,
  Container,
  ShowOptions,
  Div,
} from './SearchBarExpansive.styles';

interface SearchBarProps {
  showOptions: string[];
  searchText: string;
  placeholder: string;
  loadingSearch: boolean;
  alreadySearch: boolean;
  showErasedSearch: boolean;
  searchOnKeyDown: (event: any) => void;
  searchIconOnClick: () => void;
  closeIconOnClick: () => void;
  onClickFilter: (input: string) => void;
  searchOnChange: any;
  setShowOptions: (input: []) => void;
}
const SearchBarExpansive = ({
  searchText,
  placeholder,
  setShowOptions,
  searchOnChange,
  searchOnKeyDown,
  loadingSearch,
  showErasedSearch,
  searchIconOnClick,
  closeIconOnClick,
  alreadySearch,
  showOptions,
  onClickFilter,
}: SearchBarProps) => {
  const handleClickAway = () => {
    if (showOptions.length > 0) setShowOptions([]);
  };
  return (
    <Div>
      <SearchContainer>
        <SearchImg src={SearchNotificationImage} alt="search" />
        <Search
          haveResults={showOptions ? showOptions.length > 0 : false}
          value={searchText}
          placeholder={placeholder}
          onChange={e => searchOnChange(e.target.value)}
          onKeyDown={searchOnKeyDown}
          autoComplete="off"
        />
        {loadingSearch && <LoadingImg src={Rolling} alt="loading" />}
        {showErasedSearch && searchText.length > 0 && !loadingSearch && (
          <BActionIcon
            className="Close"
            icon="cross"
            onClick={closeIconOnClick}
          />
        )}
        {!loadingSearch &&
          !showErasedSearch &&
          (searchText.length > 0 || alreadySearch) && (
            <SearchButton onClick={searchIconOnClick}>Search</SearchButton>
          )}
      </SearchContainer>
      <ClickAwayListener onClickAway={handleClickAway}>
        <ShowOptions haveResults={showOptions.length > 0}>
          <Container haveResults={showOptions.length > 0}>
            {showOptions.map(item => (
              <StyledOption
                onClick={() => {
                  onClickFilter(item);
                }}
              >
                {item}
              </StyledOption>
            ))}
          </Container>
        </ShowOptions>
      </ClickAwayListener>
    </Div>
  );
};

export { SearchBarExpansive };
